import {ChecklistRepository} from '../repository/ChecklistRepository';
import {Checklist, ChecklistStatus} from '../models/checklist.model';

export class SetChecklistStatusUseCase {
  constructor (private checklistRepository: ChecklistRepository) {}

  async execute (id: number, status: ChecklistStatus): Promise<Checklist> {
    return this.checklistRepository.setStatus(id, status);
  }
}
